import React, { useState } from 'react';
import './AreaSelectionModal.css'; // Reusing modal styles
import './SearchFiltersModal.css';

const SearchFiltersModal = ({ isOpen, onClose, selectedAreas, onSearch, initialFilters }) => {
    const [filters, setFilters] = useState(initialFilters || {
        listingType: 'Rent', // Default
        propertyTypes: [],
        bhk: [],
        furnishing: [],
        budget: ''
    });

    // Update internal state when isOpen changes (re-sync with props if needed)
    // For now assuming initialFilters is passed fresh on open
    // We can add useEffect to sync if needed, but key prop pattern is safer or simple init.

    if (!isOpen) return null;

    const toggleFilter = (category, value) => {
        setFilters(prev => {
            const current = prev[category];
            if (Array.isArray(current)) {
                if (current.includes(value)) {
                    return { ...prev, [category]: current.filter(item => item !== value) };
                } else {
                    return { ...prev, [category]: [...current, value] };
                }
            } else {
                return { ...prev, [category]: value };
            }
        });
    };

    const handleSearch = () => {
        onSearch(filters);
    };

    const FilterSection = ({ title, children }) => (
        <div className="filter-section">
            <h3 className="filter-title">{title}</h3>
            <div className="filter-options">
                {children}
            </div>
        </div>
    );

    const FilterChip = ({ label, isSelected, onClick }) => (
        <button
            className={`filter-chip ${isSelected ? 'selected' : ''}`}
            onClick={onClick}
        >
            {label}
        </button>
    );

    return (
        <div className="modal-overlay">
            <div className="modal-content filter-modal">
                <div className="modal-header">
                    <h2>Apply Filters</h2>
                    <button className="close-btn" onClick={onClose}>&times;</button>
                </div>

                <div className="modal-body">
                    {/* Selected Areas Summary */}
                    <div className="selected-areas-summary">
                        <span className="summary-label">Searching in:</span>
                        <div className="summary-chips">
                            {selectedAreas.map(area => (
                                <span key={area} className="summary-chip">{area}</span>
                            ))}
                        </div>
                    </div>

                    <div className="filter-divider"></div>

                    {/* Listing Type */}
                    <FilterSection title="Listing Type">
                        {['Rent', 'Lease'].map(type => (
                            <FilterChip
                                key={type}
                                label={type}
                                isSelected={filters.listingType === type}
                                onClick={() => setFilters(prev => ({ ...prev, listingType: type }))}
                            />
                        ))}
                    </FilterSection>

                    {/* Property Type */}
                    <FilterSection title="Property Type">
                        {['Apartment', 'Villa', 'Independent House', 'PG'].map(type => (
                            <FilterChip
                                key={type}
                                label={type}
                                isSelected={filters.propertyTypes.includes(type)}
                                onClick={() => toggleFilter('propertyTypes', type)}
                            />
                        ))}
                    </FilterSection>

                    {/* BHK */}
                    <FilterSection title="BHK">
                        {['1', '2', '3', '4', '4+'].map(bhk => (
                            <FilterChip
                                key={bhk}
                                label={`${bhk} BHK`}
                                isSelected={filters.bhk.includes(bhk)}
                                onClick={() => toggleFilter('bhk', bhk)}
                            />
                        ))}
                    </FilterSection>

                    {/* Furnishing */}
                    <FilterSection title="Furnishing">
                        {['Fully', 'Semi', 'Unfurnished'].map(f => (
                            <FilterChip
                                key={f}
                                label={f === 'Fully' ? 'Fully Furnished' : f === 'Semi' ? 'Semi Furnished' : f}
                                isSelected={filters.furnishing.includes(f)}
                                onClick={() => toggleFilter('furnishing', f)}
                            />
                        ))}
                    </FilterSection>
                </div>

                <div className="modal-footer">
                    <button className="next-btn search-btn-modal" onClick={handleSearch}>
                        Search Properties
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SearchFiltersModal;
